export const CheckCircled = ({
    size,
    color,
}: {
    size: number;
    color: string;
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill={color}
                fillRule="evenodd"
                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-2.058-5.356L11 13.586l-2.793-2.793a1 1 0 00-1.414 1.414L9.586 15a2 2 0 002.828 0l6.688-6.687A7.967 7.967 0 0120 12z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};
